// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e1c936c8","719":"f2456091","721":"289ff0d3"}[chunkId] + ".chunk.js";
};